/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'
global.Rails = require('@rails/ujs')

ActiveStorage.start()
Turbolinks.start()
Turbolinks.setProgressBarDelay(0)
Rails.start()

require('channels')
require('trix')
require('@rails/actiontext')

global.$ = $
global.jQuery = jQuery
global.broadcasts = {}
global.toastr = require('toastr/toastr')
global.select2 = require('select2/dist/js/select2.full')
global.moment = require('moment')

import 'popper.js'
import 'bootstrap'
import 'jquery-sidebar'
// import 'flatpickr'

import './old/appointments'
import './old/null_appointments'
// import './old/dashboard_settings' // ???
import './old/main'
import './old/services'
import './old/time_slots'
import './old/pages/google_calendar_sync'
import './old/pages/offices'
import './old/pages/tags'
import './old/ui/alert'
import './old/ui/button_back'
import './old/ui/datepicker'
import './old/ui/dropdown'
import './old/ui/file_input'
import './old/ui/modal'
import './old/ui/preloader'
import './old/ui/select'
import './old/ui/sidebar'
import './old/ui/table'
import './old/ui/textarea'
import './components/note_drafts'

import * as Modal from './old/ui/modal'
import * as Datepicker from './old/ui/datepicker'
import * as Selector from './old/ui/select'
import { DuplicateForm } from './old/appointments'
import { flashMessages } from './old/main'

global.initModal = Modal.initModal
global.openModal = Modal.openModal
global.updateModal = Modal.updateModal
global.closeModal = Modal.closeModal
global.initDatePicker = Datepicker.initDatePicker
global.initSelect2 = Selector.initSelect2
global.DuplicateForm = DuplicateForm
global.flashMessages = flashMessages

import './application.sass'
// Support component names relative to this directory:
const componentRequireContext = require.context("components", true);
const ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
